(function () {
  if (window.__ppfLanding) return;
  window.__ppfLanding = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = null;
  if (!reduceMotion && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
  }

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.ppf-reveal:not(.is-in)');
    els.forEach(function (el) {
      if (io) {
        io.observe(el);
      } else {
        el.classList.add('is-in');
      }
    });
  }

  // Before/after comparison slider (range input drives the clip position)
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('ppf-compare-range')) {
      var frame = t.closest('.ppf-compare-frame');
      if (frame) frame.style.setProperty('--pos', t.value + '%');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal(document);
    });
  } else {
    initReveal(document);
  }

  // Re-init inside the Shopify Theme Editor
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
  });
})();
